import $ from 'jquery';
import Swiper from 'swiper';
import Component from '../model/Component';

class ProductBarSliderComponent extends Component {
    constructor(element, parentCtrl) {
        super(element, parentCtrl);

        this.$element = $(element);
        this.spv = 0;

        $(window).resize(() => {
            this.onResize();
        })
        this.onResize();
    }

    onResize() {
        let newSpv = null;
        if ($(window).width() > 767) {
            newSpv = 2;
        } else {
            newSpv = 1;
        }

        if (newSpv != this.spv) {
            this.spv = newSpv;
            this.destroySwiper();
            this.initSwiper();
        }
    }

    initSwiper() {
        this.swiper = new Swiper(this.$element[0], {
            slidesPerView: this.spv,
            nextButton: '.products_links .swiper-button-next',
            prevButton: '.products_links .swiper-button-prev',
            loop: true,
            speed: 1000,
            autoplay: 3000
        })
    }

    destroySwiper() {
        if (!!this.swiper) {
            this.swiper.destroy(true, true);
            delete this.swiper;
        }
    }
}

export default ProductBarSliderComponent;
